import ReactSelect from 'react-select'

const AutocompleteSelect = ({
  name,
  label,
  options,
  value,
  className,
  onChange,
  reactSelectOptions = {},
}) => (
  <div className={className}>
    {label && (
      <label className="mb-1 block text-sm text-gray-700" htmlFor={name}>
        {label}
      </label>
    )}
    <ReactSelect
      name={name}
      options={options}
      onChange={onChange}
      defaultValue={value}
      classNamePrefix="fs"
      styles={{
        menu: (base) => ({ ...base, zIndex: 9999 }),
      }}
      {...reactSelectOptions}
    />
  </div>
)

export default AutocompleteSelect
